;(function() {
  'use strict'

  Directive.$inject = ["chainService"];
  angular.module('app.page').directive('moduleSurvey', Directive)

  /* @ngInject */
  function Directive(chainService) {
    controller.$inject = ["$scope", "$state"];
    return {
      restrict: 'E',
      scope: {
        page: '=',
        module: '=',
      },
      templateUrl: 'module-survey.template.html',
      link: link,
      controller: controller,
    }

    function link(scope, elem) {
      elem.addClass('module-survey')
    }

    /* @ngInject */
    function controller($scope, $state) {
      $scope.goToSurvey = goToSurvey

      function goToSurvey() {
        chainService.update({ moduleId: $scope.module.id })
        chainService.hold()

        $state.go('app.survey', { id: $scope.module.data.surveyId })
      }
    }
  }
})()
